import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, Select } from 'seagull';
export function OAuthBusinessSelector(props) {
    const { options, selectedBusinessId, onChange, testId } = props;
    return /*#__PURE__*/ _jsx(Select, {
        bi: {
            name: 'oauth_business_select'
        },
        testId: testId,
        value: selectedBusinessId,
        onChange: (event)=>onChange(event.target.value),
        fullWidth: true,
        children: options.map((option)=>/*#__PURE__*/ _jsx(MenuItem, {
                value: option.id,
                label: option.name,
                testId: "".concat(testId, "-option-").concat(option.id),
                children: option.name
            }, option.id))
    });
}
